module.exports = __webpack_public_path__ + "static/img/title-software.aa912b57.png";